import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import OpenBookImage from '../../../assets/img/app/OpenBook.webp';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

const BlogCard = ({ blog }) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();

  if (!blog) {
    console.error('BlogCard received undefined blog prop');
    return null;
  }
  const {
    id,
    title = 'Untitled',
    author = 'Anonymous',
    publishedAt,
    image
  } = blog;

  // Use the provided image URL or fall back to the imported OpenBookImage
  const imageSource = image || OpenBookImage;

  return (
    <Link to={`/blog/${id}`} className="block">
      <div className={`${semantic.contentCardBg} ${semantic.contentCardBorder} rounded-lg shadow-md overflow-hidden transition-transform hover:scale-[1.02]`}>
        <div className="relative h-48 w-full">
          <img
            src={imageSource}
            alt={replace(title)}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = OpenBookImage;
              console.warn('Failed to load blog image:', image);
            }}
          />
        </div>
        
        <div className="p-6">
          <h2 className={`text-xl font-bold ${semantic.contentCardHeading} mb-2 hover:${semantic.contentCardLink}`}>
            {replace(title)}
          </h2>
          
          <div className={`text-sm ${semantic.formLabel} mb-4`}>
            {replace('By')} {replace(author)} • {publishedAt ? format(new Date(publishedAt), 'MMM d, yyyy') : replace('Draft')}
          </div>
          
          <div className={`inline-flex items-center ${semantic.contentCardLink}`}>
            {replace('View Post')}
            <svg
              className="w-4 h-4 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
};

BlogCard.propTypes = {
  blog: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string,
    content: PropTypes.string,
    author: PropTypes.string,
    publishedAt: PropTypes.string,
    image: PropTypes.string
  }).isRequired
};

export default BlogCard;

